export const _updateToolTipClear = () => {
  const elementToolTip: any = document.querySelector('.rs-picker-toggle-clean.rs-btn-close');
  if (elementToolTip) {
    elementToolTip.setAttribute('title', 'Borrar');
  }
};
